// extracted by mini-css-extract-plugin
export default {"editor":"Textarea__editor--mW5iG"};